import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPostKey } from '../../utils/keys';
import { useAuthMember } from '../auth';
import { getCachedRootPostByReplies, infinitePostUpdater, removeReactionFromPost, infinitePostArrayUpdater, getCachedPost, } from '../cache/useCachedPost';
import { pinnedPostsFilter, postsQueryFilter } from './filters';
export const useRemoveReaction = (options) => {
    const queryClient = useQueryClient();
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const { data: authMember } = useAuthMember();
    return useMutation((input) => client.posts.removeReaction(input), {
        onMutate: async (variables) => {
            const { reaction, postId } = variables;
            // updating the post itself
            const postKey = getPostKey({ variables: { id: postId } });
            await queryClient.cancelQueries(postKey);
            const postSnapshot = getCachedPost(postId, queryClient);
            if (postSnapshot) {
                queryClient.setQueriesData(postKey, removeReactionFromPost(reaction, authMember.id));
            }
            // updating pinned posts within the space
            const pinnedPostsSnapshot = queryClient.getQueriesData(pinnedPostsFilter);
            if (pinnedPostsSnapshot) {
                queryClient.setQueriesData(pinnedPostsFilter, oldPosts => oldPosts.map(infinitePostArrayUpdater(postId, removeReactionFromPost(reaction, authMember.id), true)));
            }
            // take a snapshot from all matched posts queries
            const postsSnapshots = queryClient.getQueriesData(postsQueryFilter);
            // update posts and replies within the found post everywhere (posts and the feed queries)
            queryClient.setQueriesData(postsQueryFilter, infinitePostUpdater(postId, removeReactionFromPost(reaction, authMember.id), true));
            // updating root post if adding the reaction on a reply if no feed/posts have found
            let rootPostSnapshot;
            let rootPostKey;
            if (!(pinnedPostsSnapshot === null || pinnedPostsSnapshot === void 0 ? void 0 : pinnedPostsSnapshot.length) && !(postsSnapshots === null || postsSnapshots === void 0 ? void 0 : postsSnapshots.length)) {
                const rootPost = getCachedRootPostByReplies(postId, queryClient);
                if (rootPost && rootPost.replies && rootPost.id !== postId) {
                    rootPostKey = getPostKey({ variables: { id: rootPost === null || rootPost === void 0 ? void 0 : rootPost.id } });
                    rootPostSnapshot = getCachedPost(rootPost === null || rootPost === void 0 ? void 0 : rootPost.id, queryClient);
                    if (rootPostSnapshot) {
                        queryClient.setQueriesData(rootPostKey, infinitePostArrayUpdater(postId, removeReactionFromPost(reaction, authMember.id), true));
                    }
                }
            }
            return [
                [postKey, postSnapshot],
                [rootPostKey, rootPostSnapshot],
                ...pinnedPostsSnapshot,
                ...postsSnapshots,
            ];
        },
        onError: (error, variables, context) => {
            context.forEach(([queryKey, snapshot]) => {
                if (queryKey) {
                    queryClient.setQueriesData(queryKey, snapshot);
                }
            });
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useRemoveReaction.js.map